import { getRequest, postRequest } from "../tools/ajax.js";
import axios from 'axios';

// 获取所有关联案件
const getCaseLinkApi = (params) => postRequest("/api/Pc/Case/CaseLink", params);

// 获取所有关联案件
const getCaseInfoLinkApi = (params) => postRequest("/api/Pc/Case/CaseInfoLink", params);

// 获取案件类型
const getCaseTypeApi = (params) => getRequest("/api/Pc/Case/Select", params);

// 获取案件/获取案件明细
const allCaseApi = (params) => postRequest("/api/Pc/Case/Select", params);

//获取全部破除案件的统计
const SelectBankStatistics = (params) => postRequest("/api/Pc/option/SelectBankStatistics", params);

// 录入案件
const caseInputApi = (params) => postRequest("/api/Pc/Case/Insert", params);

// 冲突案件检索
const caseConflictApi = (params) => postRequest("/api/Pc/Option/CaseConflict", params);
const BanruptcykConflictApi = (params) => postRequest("/api/Pc/Option/BanruptcykConflict", params);

// 更新案件
const caseUpdateApi = (params) => postRequest("/api/Pc/Case/Update", params);

// 获取项目日志
const caseLogApi = (params) => postRequest("/api/Pc/Option/CaseLog", params);

// 案件用章申请单独添加
const caseSealApi = (params) => postRequest("/api/Pc/Option/SealApply", params);

// 案件附件更新
const fileUpdateApi = (params) => postRequest("/api/Pc/Option/Fileupload", params);

// 单条案件所有附件
const caseFileApi = (params) => postRequest("/api/Pc/Case/BankruptFile", params);

// 案件附件删除
const FileDel = params => postRequest('/api/pc/Option/FileDel', params);

// 获取代理律师/主办律师/获取二次审批人
const caseLawyerApi = params => postRequest("/api/Pc/Option/Lawyer", params)

// 冲突顾问检索
const caseAdviserApi = params => postRequest("/api/Pc/Option/AdviserConflict", params)

// 删除案件
const caseDeleteApi = params => postRequest("/api/Pc/Case/Delete", params)

// 获取部门主管
const caseDepartmentLeadersApi = params => postRequest("/api/Pc/Option/GetDepartmentLeaders", params)

// 获取录入权限
const caseInsertMenu = params => postRequest("/api/Pc/First/EnterMenu", params)

// 更改协理律师
const UpdateLawyer = params => postRequest('/api/pc/Option/UpdateLawyer', params);

// 文档打印判断（返回去重后的律所）
const filesPrintLvSuoApi= params => postRequest('/api/pc/Case/FilesPrintLvSuo', params);

// 文档打印（打印信息）
const filesPrintInfoApi = params => postRequest('/api/pc/Case/FilesPrintInfo', params);

// 案件受理
const CaseAppect = params => postRequest('/api/pc/Case/CaseAppect', params);

// 案件受理
const getLvSuo = params => getRequest('/api/pc/Case/GetLvSuo', params);

// 电子归档文件查询
const getEText = params => getRequest('/api/pc/Case/EText', params);

// 获取数据时间
const getPostTime = params => getRequest('/api/pc/Case/GetPostTime', params);

//导出数据
const Exportdata = params => postRequest('/api/pc/Case/Exportdata', params);

// 获取文档
const getNewSealType = (params) => postRequest("/api/Pc/Case/GetNewSealType", params);

// 获取文档
const getLitigant = (params) => postRequest("/api/Pc/Case/GetLitigant", params);

// 获取文档
const changeLitigant = (params) => postRequest("/api/Pc/Case/ChangeLitigant", params);

const caseReject = (params) => postRequest("/api/Pc/Case/CaseReset", params);

const bkInsert = (params) => postRequest("/api/Pc/Bankruptcy/BkInsert", params);

const bkSelect = (params) => postRequest("/api/Pc/Bankruptcy/BkSelect", params);

const BKCaseConflict = (params) => postRequest("/api/Pc/Bankruptcy/BKCaseConflict", params);

const oldSelect = (params) => getRequest("/api/Pc/Bankruptcy/OldSelect", params);

const bkDelete = (params) => getRequest("/api/Pc/Bankruptcy/BkDelete", params);

const bkUpdate = (params) => postRequest("/api/Pc/Bankruptcy/BkUpdate", params);

const examineCase = (params) => postRequest("/api/Pc/Bankruptcy/ExamineCase", params);

const caseSuccess = (params) => postRequest("/api/Pc/Bankruptcy/CaseSuccess", params);

const reject = (params) => postRequest("/api/Pc/Bankruptcy/CaseReject", params);

const printInfo = (params) => postRequest("/api/Pc/Bankruptcy/FilesPrintInfo", params);

const printLvSuoApi = params => postRequest('/api/pc/Bankruptcy/FilesPrintLvSuo', params);

const caseLog = params => postRequest('/api/pc/Bankruptcy/CaseLog', params);

// 未审核
const unProcess =  params => postRequest('/api/pc/Bankruptcy/CaseProcess', params);

//已审核流程
const logProcess =  params => postRequest('/api/pc/Bankruptcy/CaseApprover', params);

const noticeInsert =  params => postRequest('/api/pc/Notice/Insert', params);

const unreadSelect = params => postRequest('/api/pc/Notice/UnreadSelect', params);

const readSelect = params => postRequest('/api/pc/Notice/ReadSelect', params);

const unreadToRead = params => getRequest('/api/pc/Notice/UnreadToRead', params);

//获取所有当事人
const GetAllLitigant = (params) => postRequest("/api/Pc/Case/GetAllLitigant", params);
// 文件上传
const filesUpApi = params => axios({
  url: '/api/Filer/PrintUpload',
  method: 'post',
  headers: {
    'Content': 'multipart/form-data'
  },
  params
});

function getFile (url) {
  return axios.request({
    url: url,
    method: 'get',
    responseType: 'blob'
  })
}

function etext (url) {
  return axios.request({
    url: url,
    method: 'get',
    responseType: 'blob'
  })
}
// 二次利冲审批人
const ConflictMember = params => postRequest('/api/pc/Option/ConflictMember', params);
export {
  Exportdata,
  getCaseLinkApi,
  allCaseApi,
  caseInputApi,
  getCaseTypeApi,
  caseConflictApi,
  caseUpdateApi,
  caseLogApi,
  caseSealApi,
  fileUpdateApi,
  caseFileApi,
  FileDel,
  caseLawyerApi,
  caseAdviserApi,
  caseDeleteApi,
  caseDepartmentLeadersApi,
  caseInsertMenu,
  UpdateLawyer,
  filesPrintLvSuoApi,
  filesPrintInfoApi,
  filesUpApi,
  CaseAppect,
  getLvSuo,
  getEText,
  getFile,
  etext,
  getPostTime,
  getNewSealType,
  getCaseInfoLinkApi,
  getLitigant,
  changeLitigant,
  caseReject,
  bkInsert,
  bkSelect,
  oldSelect,
  bkDelete,
  bkUpdate,
  examineCase,
  caseSuccess,
  reject,
  printInfo,
  printLvSuoApi,
  caseLog,
  unProcess,
  logProcess,
  noticeInsert,
  unreadSelect,
  readSelect,
  unreadToRead,
  SelectBankStatistics,
  ConflictMember,
  GetAllLitigant,
  BKCaseConflict,
  BanruptcykConflictApi,
};